import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';
import { HttpHelper } from '../shared/http-helper';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class AccountService {

    constructor(private httpHelper: HttpHelper) {}

    changePwd(pwdData: any): Observable<any>{
        return this.httpHelper.post(
            'auth/api/account/changepwd', 
            JSON.stringify(pwdData));
	}

	forgotPwd(pwdData: any): Observable<any>{
        return this.httpHelper.post(
            'auth/api/account/forgotpwd', 
            JSON.stringify(pwdData));
	}

    verifySecurityQuestion(email: string, answer: string): Observable<any>{
			
        let data = {
		    email: email,
			answer: answer
        };

        return this.httpHelper.post(
            'auth/api/account/validatesecurityquestion', 
            JSON.stringify(data));
	}

	getSecurityQuestionForEmail(email: string): Observable<any>{			
		let secQuestionData = {
			email: email
		};

        return this.httpHelper.post(
            'auth/api/account/securityquestion', 
            JSON.stringify(secQuestionData));
    }

	resetPwd(pwdData: any): Observable<any>{
			
        return this.httpHelper.post(
            'auth/api/account/resetpwd', 
            JSON.stringify(pwdData));
	}

	getSecurityQuestions(): Observable<any>{
        return this.httpHelper.get('auth/api/account/questions');
	}

	getAccountInfo(username: string): Observable<any>{

        var data = {
    			username: username
		};
        
        return this.httpHelper.post(
            'auth/api/account/info', 
            JSON.stringify(data));
            //JSON.stringify('username':username}));
	}

	saveSecurityQuestionAnswers(securityQuestionData: any): Observable<any>{

        return this.httpHelper.post(
            'auth/api/account/savesecurityanswer', 
            JSON.stringify(securityQuestionData));
    }

	retrieveUsername(usernameData: any): Observable<any>{

        return this.httpHelper.post(
            'auth/api/account/forgotusername', 
            JSON.stringify(usernameData));
	}

	confirmEmail(confirmationData: any): Observable<any>{

        return this.httpHelper.post(
            'auth/api/account/confirmemail', 
            JSON.stringify(confirmationData));
	}
}


/** WEBPACK FOOTER **
 ** ./app/accounts/account.service.ts
 **/